import React, { useState } from 'react'
import ResetPasswordRequestFormView from './ResetPasswordRequestFormView'
import { useResetPasswordRequest } from '../../hook/userResetPasswordRequest'

export default function ResetPasswordRequestForm() {
    const { createNewResetPasswordRequest } = useResetPasswordRequest()
    const [isDone, setIsDone] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const handleSubmit = (email: string) => {
        setError(null)
        createNewResetPasswordRequest.mutate(
            { newData: { rpr_email: email } },
            {
                onSuccess: () => {
                    setIsDone(true)
                    setError(null)
                },
                onError: (error: any) => {
                    console.error('Reset password request error:', error)
                    setError("Une erreur est survenue lors de l'envoi de la demande. Veuillez réessayer.")
                }
            }
        )
    }

    return (
        <ResetPasswordRequestFormView 
            handleSubmit={handleSubmit}
            error={error}
            isLoading={createNewResetPasswordRequest.isPending}
            isDone={isDone}
        />
    )
}
